import React from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import Loading from "../Loading";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Model from "../Model";
import moment from "moment";
import Images from "../../Images";
import * as Yup from "yup";
import { toast } from "react-toastify";

const EditDetail = ({
  editMoveoutMutate,
  editEntryLoading,
  setEditUser,
  selectedData,
}) => {
  const SubmitHandler = (values) => {
    if (!values.tenantName) {
      toast.error("Please enter your Name");
      return;
    }
    editMoveoutMutate(values);
  };

  const formik = useFormik({
    initialValues: {
      tenantName: selectedData?.tenantName || "",
      tenantMobile: selectedData?.tenantMobile || "",
      moveInDate: moment(selectedData?.moveInDate).format("YYYY-MM-DD"),
      moveOutDate: moment(selectedData?.moveOutDate).format("YYYY-MM-DD"),
    },
    validationSchema: Yup.object().shape({
      tenantName: Yup.string().required("Name is required"),
      tenantMobile: Yup.string()
        .matches(/^\d{10}$/, "Enter a valid number")
        .required("Mobile number is required"),
      moveInDate: Yup.date().required("Move in date is required"),  
      moveOutDate: Yup.date().required("Move out date is required"),  
    }),
    onSubmit: SubmitHandler,
    enableReinitialize: true,
  });

  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setEditUser}>
      <Title>Edit Details</Title>

      {editEntryLoading ? (
        <Loading />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Wrapper>
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="tenantName">Name</Label>
                <FieldWrapper>
                  <Input
                    type="text"
                    name="tenantName"
                    id="tenantName"
                    value={formik.values.tenantName}
                    onChange={formik.handleChange}
                    autoComplete="off"
                    disabled
                    className="bg-gray-100"
                  />
                  {formik.touched.tenantName && formik.errors.tenantName && (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.tenantName}
                    </p>
                  )}
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                  <Label htmlFor="tenantMobile">Tenant Mobile</Label>
                  <FieldWrapper>
                    <Input
                      type="text"
                      name="tenantMobile"
                      id="tenantMobile"
                      className="bg-gray-100"
                      autoComplete="off"
                      value={formik.values.tenantMobile}
                      onChange={formik.handleChange}
                      maxLength={10}
                      pattern="[0-9]{10}"
                      disabled
                    />
                    {formik.touched.tenantMobile && formik.errors.tenantMobile ? (
                      <p className="text-rose-600 text-sm">
                        {formik.errors.tenantMobile}
                      </p>
                    ) : null}
                  </FieldWrapper>
                </InputGroup>
            
            </CombineInputGroup>
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="moveInDate">Move In Date</Label>
                <FieldWrapper>
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="absolute w-4 left-2 top-3"
                  />
                  <Input
                    type="date"
                    name="moveInDate"
                    id="moveInDate"
                    className="pl-8 bg-gray-100"
                    value={formik.values.moveInDate}
                    onChange={formik.handleChange}
                    disabled
                  />
                  {formik.touched.moveInDate && formik.errors.moveInDate && (
                    <p className="text-rose-600 text-sm">
                      {formik.errors.moveInDate}
                    </p>
                  )}
                </FieldWrapper>
              </InputGroup>
              <InputGroup>
                  <Label htmlFor="moveOutDate">Move Out Date</Label>
                  <FieldWrapper>
                    <img
                      src={Images.Calender}
                      alt="Calender icon"
                      className="absolute w-4 left-2 top-3"
                    />
                    <Input
                      type="date"
                      name="moveOutDate"
                      id="moveOutDate"
                      className="pl-8"
                      value={formik.values.moveOutDate}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.moveOutDate &&
                      formik.errors.moveOutDate && (
                        <p className="text-rose-600 text-sm">
                          {formik.errors.moveOutDate}
                        </p>
                      )}
                  </FieldWrapper>
                </InputGroup>
            </CombineInputGroup>
          </Wrapper>
          <BtnWrapper>
            <SubmitBtn type="submit">Update</SubmitBtn>
          </BtnWrapper>
        </form>
      )}
    </Model>
  );
};

const Wrapper = tw.div`grid gap-6 my-6 px-1`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const FieldWrapper = tw.div`w-full relative`;
const CombineInputGroup = tw.div`flex space-x-7`;
const Input = tw.input`truncate border border-gray-300 border-m rounded-md pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;

export default EditDetail;
